<template>
  <div>
    <div class="infoUser">
      <span v-if="puntaje">Puntaje: {{ puntaje }}</span>
      <div class="user">
        <img :src="img" alt="Avatar" />
        <div class="user-content">
          <router-link to="/menu">Menu</router-link>
          <router-link to="/perfil">Perfil</router-link>
          <a @click="salir()">Cerrar Sesion</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: { img: String, puntaje: Number },
  name: "UserImage",
  data() {
    return {};
  },
  methods: {
    salir() {
      this.$gAuth.signOut();
      localStorage.removeItem("token");
      this.$router.push("/");
    },
  },
  mounted() {
    console.log(this.img);
  },
  watch: {
    img(nuevoValor, valorAnterior) {
      console.log(
        "El comenzar pasó de ser '%s' a '%s'",
        valorAnterior,
        nuevoValor
      );
      //   this.comenzarJuego();
    },
  },
};
</script>
<style scoped>
.infoUser {
  position: absolute;
  display: flex;
  align-items: center;
  right: 0;
  margin: 1rem;
  cursor: pointer;
}
.user {
  position: relative;
  cursor: pointer;
  right: 0;
  /* margin: 1rem; */
}
.infoUser span {
  color: white;
  font-weight: bold;
  font-family: "Exo 2", sans-serif !important;
  margin-right: 1rem;
  font-size: 1.5rem;
}
img {
  position: relative;
  width: 3rem;
  border-radius: 50%;
}
.user-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  z-index: 1;
  left: -113px;
  top: 3rem;
  cursor: pointer;
}
.user-content a {
  display: block;
  margin-bottom: 0.4rem;
}
.user-content a:hover {
  transform: scale(1.1);
  font-weight: bold;
}
.infoUser:hover .user-content {
  display: block;
}
</style>
